module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD4SURBVHgBrZLBDYJAEEV3ly3AErQDSrAErUApwRNwEk8QTnbAWoEt2IF2ICVw4wT4fxyMMWLU8JPNLLPz3w6b0Xme+03TFFprX/2nEv6lbdv2CMiUia7rDj8AFHwrhKm1trDcEMLIA8B2cRy7T4A0TeeoLcRTwePrLMs6mglDcivgE3IBgOUbAGvm8gcB98zZvki6cChe8wDrikucXKKkA5oqxE0Yhvsezmhe2yYwiqKZAGi8yvKZq+t61kOeZdWAAExwmzPGLPgNgEuSpBqqHwQJrETYqy9k1EgaDaTxDmc85OTXYXwA7kOprOd5gUz3Vv0hNHAh4wb4KnbG/fiXKQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ico-mail.png
// module id = RO3P
// module chunks = 46